import _define_property from "@swc/helpers/src/_define_property.mjs";
import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import _object_spread_props from "@swc/helpers/src/_object_spread_props.mjs";
import { setSeconds } from "date-fns/setSeconds";
import { setMinutes } from "date-fns/setMinutes";
import { setHours } from "date-fns/setHours";
import { addDays } from "date-fns/addDays";
import { isDestDateBeforeDepDate, formatDate, isDeptDateInLessThanDays, isSearchInCuba } from "./utils";
import { ActionType } from "./types";
var LOCATION_FIELD_NAME = {
    departure: "depLocation",
    destination: "destLocation"
};
export var DEFAULT_AGE = 47;
var today = new Date();
export var DEFAULT_DEPARTURE_DATE = setSeconds(setMinutes(setHours(addDays(today, 7), 12), 0), 0);
export var DEFAULT_DESTINATION_DATE = setSeconds(setMinutes(setHours(addDays(today, 14), 9), 0), 0);
export var DEFAULT_VALUES = {
    affiliate: "",
    customerAge: DEFAULT_AGE,
    depLocation: null,
    destLocation: null,
    depDate: formatDate(DEFAULT_DEPARTURE_DATE),
    destDate: formatDate(DEFAULT_DESTINATION_DATE),
    dateError: "",
    locationError: "",
    axiosError: "",
    showDestLocation: false,
    history: {
        items: []
    },
    inputValue: {
        departure: "",
        destination: ""
    }
};
export var makeTranslatedSearchReducer = function(translate) {
    return function(state, action) {
        switch(action.type){
            case ActionType.POPULATE_FORM:
                return _object_spread_props(_object_spread({}, state, action.payload), {
                    showDestLocation: !!action.payload.destLocation
                });
            case ActionType.POPULATE_HISTORY_ITEMS:
                return _object_spread_props(_object_spread({}, state), {
                    history: action.payload.history
                });
            case ActionType.SET_CUSTOMER_AGE:
                return _object_spread_props(_object_spread({}, state), {
                    customerAge: action.payload.customerAge
                });
            case ActionType.SET_DATE:
                {
                    var date = formatDate(action.payload.date);
                    var field = action.payload.direction === "departure" ? "depDate" : "destDate";
                    var hasError = action.payload.direction === "departure" ? isDestDateBeforeDepDate(state.destDate, date) : isDestDateBeforeDepDate(date, state.depDate);
                    var _obj;
                    return _object_spread_props(_object_spread({}, state), (_obj = {}, _define_property(_obj, field, date), _define_property(_obj, "dateError", hasError ? translate("errorTexts.time") : ""), _obj));
                }
            case ActionType.SET_LOCATION:
                {
                    var _payload = action.payload, direction = _payload.direction, location = _payload.location;
                    var field1 = LOCATION_FIELD_NAME[direction];
                    var _obj1;
                    return _object_spread_props(_object_spread({}, state), (_obj1 = {}, _define_property(_obj1, field1, location), _define_property(_obj1, "inputValue", _object_spread({}, state.inputValue, location ? _define_property({}, direction, location.name) : {})), _obj1));
                }
            case ActionType.SET_LOCATION_INPUT_VALUE:
                {
                    var _payload1 = action.payload, direction1 = _payload1.direction, value = _payload1.value;
                    return _object_spread_props(_object_spread({}, state), {
                        inputValue: _object_spread_props(_object_spread({}, state.inputValue), _define_property({}, direction1, value))
                    });
                }
            case ActionType.SET_ERROR:
                {
                    if (action.payload === null) {
                        return _object_spread_props(_object_spread({}, state), {
                            dateError: "",
                            locationError: "",
                            axiosError: ""
                        });
                    }
                    var _payload2 = action.payload, kind = _payload2.kind, message = _payload2.message;
                    return _object_spread_props(_object_spread({}, state), _define_property({}, kind, message));
                }
            case ActionType.SET_SEARCH_FROM_HISTORY:
                {
                    var _payload3 = action.payload, depLocation = _payload3.depLocation, destLocation = _payload3.destLocation;
                    return _object_spread_props(_object_spread({}, state, action.payload), {
                        showDestLocation: Boolean(destLocation),
                        inputValue: _object_spread_props(_object_spread({}, state.inputValue, depLocation ? {
                            departure: depLocation.name
                        } : {}), {
                            destination: (destLocation === null || destLocation === void 0 ? void 0 : destLocation.name) || ""
                        })
                    });
                }
            case ActionType.SET_SHOW_DEST_LOCATION:
                return _object_spread(_object_spread_props(_object_spread({}, state), {
                    showDestLocation: action.payload
                }), action.payload ? {} : {
                    destLocation: null,
                    inputValue: _object_spread_props(_object_spread({}, state.inputValue), {
                        destination: ""
                    })
                });
            case ActionType.VALIDATE:
                if (isDeptDateInLessThanDays(state.depDate, 0)) {
                    return _object_spread_props(_object_spread({}, state), {
                        dateError: translate("errorTexts.time")
                    });
                }
                if (isDestDateBeforeDepDate(state.destDate, state.depDate)) {
                    return _object_spread_props(_object_spread({}, state), {
                        dateError: translate("errorTexts.time")
                    });
                }
                if (isSearchInCuba(state.depLocation, state.destLocation) && isDeptDateInLessThanDays(state.depDate, 30)) {
                    return _object_spread_props(_object_spread({}, state), {
                        locationError: translate("errorTexts.cuba")
                    });
                }
                return state;
            default:
                return state;
        }
    };
};
